import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import CTASection from "../components/sections/CTASection";
import { SITE_URL } from "../config/site";

const sections = [
  ["Who we are", "Indiana Accident Aid is a free educational resource that helps Indiana accident and injury victims understand their options and, when they choose, connects them with independent local attorneys. We are not a law firm and do not provide legal advice."],
  ["How our content is created", "Our guides are researched and written to explain Indiana accident and injury topics in plain language. Every article is reviewed and edited by our editorial team before publication. Aaron Bankhurst, our founder and editor, oversees research, content development, and editorial standards."],
  ["Sourcing and factual integrity", "We follow an evidence-first standard: specific legal rules are tied to primary sources. Indiana statutes are cited and linked to the official Indiana General Assembly code, and government references link to official state or federal agencies. We do not publish fabricated statistics, invented settlement figures, or specific claims we cannot support. Where an exact figure cannot be verified, we describe the concept qualitatively instead."],
  ["Legal review", "Articles are written for general information. We do not overstate expertise. When a qualified professional has reviewed a specific article, that reviewer is named directly on that article in a \"Reviewed by\" line. The absence of a reviewer line means the article reflects our editorial research and has not been individually reviewed by an outside professional."],
  ["Updates", "We revise articles as laws and best practices change. Substantive updates are reflected in the article's modified date."],
];

export default function EditorialPolicy() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "Editorial Policy",
    "url": `${SITE_URL}/editorial-policy`,
    "publisher": { "@type": "Organization", "name": "Indiana Accident Aid", "url": SITE_URL },
  };
  return (
    <>
      <SEO
        title="Editorial Policy | Indiana Accident Aid"
        description="How Indiana Accident Aid researches, writes, sources, and reviews its accident and injury guides — including our evidence-first factual standard."
        schema={schema}
        canonical={`${SITE_URL}/editorial-policy`}
      />
      <section className="pt-12 md:pt-20 pb-8 px-6 bg-bone" data-testid="editorial-policy">
        <div className="max-w-3xl mx-auto">
          <div className="overline mb-3">Editorial Standards</div>
          <h1 className="text-4xl md:text-6xl font-display font-bold text-forest tracking-tight mb-5">Editorial Policy</h1>
          <p className="text-lg md:text-xl text-charcoal-soft leading-relaxed">
            We hold Indiana Accident Aid's content to a clear, transparent standard. Here is how our
            guides are researched, written, sourced, and reviewed.
          </p>
        </div>
      </section>
      <section className="px-6 pb-16">
        <div className="max-w-3xl mx-auto space-y-10">
          {sections.map(([h, p]) => (
            <div key={h}>
              <h2 className="text-2xl md:text-3xl font-display font-bold text-forest mb-3">{h}</h2>
              <p className="text-base md:text-lg text-charcoal-soft leading-relaxed">{p}</p>
            </div>
          ))}
          <p className="text-sm text-charcoal-soft border-t border-black/5 pt-6">
            Found something that needs fixing? See our{" "}
            <Link to="/corrections" className="text-forest underline hover:text-terracotta">Corrections Policy</Link>.
          </p>
        </div>
      </section>
      <CTASection />
    </>
  );
}
